import { TOrganizi8AppState } from '../organizi8.reducer';
import { TransferDBActions, TTransferActionTypes } from './transfer.actions';

const initialState: TOrganizi8AppState['transfer'] = {
  availableLocationsListing: {},
  itemsStoredDetails: {},
  newLocationDetails: {},
};

export const TransferStateReducer = (
  state = initialState,
  action: TTransferActionTypes,
): TOrganizi8AppState['transfer'] => {
  switch (action.type) {
    case TransferDBActions.ClearAndFetchAvailableLocationsListing: {
      return {
        ...state,
        availableLocationsListing: {},
      };
    }
    case TransferDBActions.ClearAndFetchAvailableLocationsListingSuccess: {
      return {
        ...state,
        availableLocationsListing: {
          res: action.res,
        },
      };
    }
    case TransferDBActions.ClearAndFetchItemsStoredInLocationDetails: {
      return {
        ...state,
        itemsStoredDetails: {},
      };
    }
    case TransferDBActions.ClearAndFetchItemsStoredInLocationDetailsSuccess: {
      return {
        ...state,
        itemsStoredDetails: {
          res: action.res,
        },
      };
    }
    case TransferDBActions.GetNewLocationDetails: {
      return {
        ...state,
        newLocationDetails: {},
      };
    }
    case TransferDBActions.GetNewLocationDetailsSuccess: {
      return {
        ...state,
        newLocationDetails: {
          res: action.res,
        },
      };
    }
  }
  return state;
};
